export const styles = {
  dialogActions: {
    padding: '8px 24px 16px',
  },
}
